interface Props {
  direction: false | "asc" | "desc";
}

export default function SortIcon({ direction }: Props) {
  const inactive = "rgba(255,255,255,0.35)";
  const active = "#2CCD1E";
  const upColor = direction === "asc" ? active : inactive;
  const downColor = direction === "desc" ? active : inactive;

  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ marginLeft: 6, flexShrink: 0 }}>
      {/* Up arrow (left side) */}
      <path
        d="M4.21875 1.87502V13.125 M6.5625 4.21878L4.21875 2.06909L1.875 4.21878"
        stroke={upColor}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Down arrow (right side) */}
      <path
        d="M10.7381 1.79065V12.1032 M13.0819 10.4232L10.7381 12.5728L8.39438 10.4232"
        stroke={downColor}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
